import { render, staticRenderFns } from "./ComponentSymbolDetailDialog.vue?vue&type=template&id=af6a78c4&scoped=true"
import script from "./ComponentSymbolDetailDialog.vue?vue&type=script&lang=js"
export * from "./ComponentSymbolDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ComponentSymbolDetailDialog.vue?vue&type=style&index=0&id=af6a78c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6a78c4",
  null
  
)

export default component.exports